module.exports = __webpack_public_path__ + "img/1575274532.3480e331.jpg";